import socket from "../static/js/socket.js"
import UserActivity from "../static/js/user_activity.js"
import UserActivityCable from "../static/js/user_activity_cable.js"

const element = document.getElementById("user-activity")

// Транспорт выбирает сервер (feature flag): action_cable — встроенный ActionCable,
// иначе — легаси Phoenix-трекер. Ровно один трекер на страницу: reject подписки
// ActionCable трекинг останавливает, на легаси-путь не откатывается.
if (element && element.getAttribute("data-transport") === "action_cable") {
    UserActivityCable.init(element)
} else {
    // data-state=legacy — маркер, что выбор транспорта отработал (см. data-state в user_activity_cable.js)
    if (element) { element.setAttribute("data-state", "legacy") }
    UserActivity.init(socket, element)
}
